/*
  assets/littleg-daily-mission-flow.js — GAME-REFERENCE-SYSTEM-01-09
  Updated: 2026-07-21
  Owner: /pages/game 01–09 local screen routing, shared in-page header state and interaction.
  Header owner: sections/littleg-game-lobby.liquid.
  Navigation owner: snippets/littleg-app-sidebar.liquid.
  Boundary: no global navigation ownership, GFun, customer, cart, checkout, payment,
  entitlement or external API mutation. sessionStorage is temporary UI continuity only.
*/
(function littleGGameRuntime(window, document) {
  'use strict';

  var html = document.documentElement;
  var ROOT_SELECTOR = '[data-littleg-game-app]';
  var VIEWS = ['lobby', 'brief', 'photo', 'guess', 'reveal', 'card', 'share', 'map', 'profile'];
  var HEADER_BY_VIEW = {
    lobby: { mode: 'full', stats: true },
    brief: { mode: 'full', stats: true },
    photo: { mode: 'minimal', stats: false },
    guess: { mode: 'full', stats: true },
    reveal: { mode: 'full', stats: true },
    card: { mode: 'back', stats: false },
    share: { mode: 'back', stats: false },
    map: { mode: 'minimal', stats: false },
    profile: { mode: 'minimal', stats: false }
  };
  var DEFAULT_PHOTO_SECONDS = 24;
  var STORAGE_PREFIX = 'littleg_game_reference_';

  html.classList.add('js', 'lg-game-app-active');

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function clean(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function isView(value) {
    return VIEWS.indexOf(clean(value)) !== -1;
  }

  function getUrl() {
    try { return new URL(window.location.href); } catch (_) { return null; }
  }

  function storage() {
    try { return window.sessionStorage || null; } catch (_) { return null; }
  }

  function readState(key, fallback) {
    var store = storage();
    if (!store) return fallback;
    try {
      var parsed = JSON.parse(store.getItem(STORAGE_PREFIX + key));
      return parsed == null ? fallback : parsed;
    } catch (_) {
      return fallback;
    }
  }

  function writeState(key, value) {
    var store = storage();
    if (!store) return;
    try { store.setItem(STORAGE_PREFIX + key, JSON.stringify(value)); } catch (_) {}
  }

  function emit(name, detail) {
    var payload = detail || {};
    try { document.dispatchEvent(new CustomEvent(name, { detail: payload })); } catch (_) {}
    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name.replace(/:/g, '_') }, payload));
      }
    } catch (_) {}
  }

  function resolveView(url) {
    if (!url) return 'lobby';
    var params = url.searchParams;
    var view = clean(params.get('view'));
    var screen = clean(params.get('screen'));
    var mode = clean(params.get('mode'));
    var intent = clean(params.get('intent'));

    /*
      Shopify owns `view` as the page-template selector.
      LittleG owns `screen` as the in-page state.
      Legacy URLs may still place the screen in `view`, so retain
      the fallback only after checking the canonical screen value.
    */
    if (isView(screen)) return screen;
    if (isView(view)) return view;
    if (params.get('share-card') === '1' || view === 'share') return 'share';
    if (mode === 'guess-result' || mode === 'result' || view === 'result') return 'reveal';
    if (mode === 'guess') return 'guess';
    if (view === 'clue' || params.has('clue')) return 'photo';
    if (view === 'atlas') return 'map';
    if ((params.get('entry') === 'today' && params.get('start') === '1') || intent === 'immersive-mission' || clean(url.hash) === '#mission-engine') return 'brief';
    return 'lobby';
  }

  function setPageClass() {
    html.classList.add('lg-game-app-active');
    if (document.body) document.body.classList.remove('lg-game-app-active');
  }

  function toast(root, message) {
    var node = qs('[data-lg-toast]', root);
    if (!node) return;
    node.textContent = String(message || '');
    node.hidden = false;
    clearTimeout(root.__toastTimer);
    root.__toastTimer = window.setTimeout(function hideToast() { node.hidden = true; }, 2200);
  }

  function syncHeader(root, view) {
    var header = qs('[data-lg-app-header]', root);
    if (!header) return;

    var targetScreen = qs('[data-lg-screen="' + view + '"]', root);
    if (targetScreen && header.parentNode !== targetScreen) {
      targetScreen.insertBefore(header, targetScreen.firstChild);
    }
    header.hidden = false;

    var config = HEADER_BY_VIEW[view] || HEADER_BY_VIEW.lobby;
    var mode = config.mode || 'full';
    var showStatus = mode === 'minimal' || mode === 'back';
    var showBack = mode === 'back';

    header.classList.remove('lg-game-appbar--full', 'lg-game-appbar--minimal', 'lg-game-appbar--back');
    header.classList.add('lg-game-appbar--' + mode);
    header.setAttribute('data-header-mode', mode);

    var status = qs('[data-lg-header-status]', header);
    var back = qs('[data-lg-header-back]', header);
    var search = qs('[data-lg-header-search]', header);
    var notification = qs('[data-lg-header-notification]', header);
    var stats = qs('[data-lg-header-stats]', header);

    if (status) status.hidden = !showStatus;
    if (back) back.hidden = !showBack;
    if (search) search.hidden = showBack;
    if (notification) notification.hidden = showBack;
    if (stats) stats.hidden = config.stats !== true;
  }

  function stopTimer(root) {
    clearInterval(root.__photoTimer);
    root.__photoTimer = null;
  }

  function startTimer(root) {
    stopTimer(root);
    var output = qs('[data-lg-screen="photo"] [data-lg-timer]', root);
    if (!output) return;
    var remaining = Number(root.dataset.lgPhotoSeconds || DEFAULT_PHOTO_SECONDS);
    output.textContent = '00:' + String(remaining).padStart(2, '0');
    root.__photoTimer = window.setInterval(function tick() {
      remaining -= 1;
      output.textContent = '00:' + String(Math.max(0, remaining)).padStart(2, '0');
      if (remaining <= 0) {
        stopTimer(root);
        toast(root, '時間到，仍可繼續找線索或跳到猜答案。');
      }
    }, 1000);
  }

  function activate(root, view, source) {
    view = isView(view) ? view : 'lobby';
    syncHeader(root, view);
    qsa('[data-lg-screen]', root).forEach(function toggle(screen) {
      var active = clean(screen.getAttribute('data-lg-screen')) === view;
      screen.hidden = !active;
      screen.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) {
        var body = qs('.lg-game-screen__body', screen);
        if (body) body.scrollTop = 0;
      }
    });
    root.dataset.currentView = view;
    html.setAttribute('data-lg-game-view', view);
    if (view === 'photo') startTimer(root);
    else stopTimer(root);
    if (view === 'reveal') showReveal(root);
    if (view === 'map') loadMapStats(root);
    if (view === 'profile') initProfile(root);
    emit('littleg:screen-change', { view: view, source: source || 'runtime' });
  }

  function navigate(root, view, source, targetHref) {
    view = isView(view) ? view : 'lobby';
    var url = getUrl();
    if (!url) return activate(root, view, source);

    if (targetHref) {
      try {
        var target = new URL(targetHref, window.location.origin);
        ['mission_id', 'mission', 'island', 'round_key', 'place', 'place_id'].forEach(function copyParam(key) {
          if (target.searchParams.has(key)) url.searchParams.set(key, target.searchParams.get(key));
        });
      } catch (_) {}
    }

    url.searchParams.set('view', 'game');
    url.searchParams.set('screen', view);
    url.searchParams.delete('mode');
    url.searchParams.delete('share-card');
    url.searchParams.delete('clue');
    url.hash = '';
    window.history.pushState({ lgView: view }, '', url.pathname + url.search + url.hash);
    activate(root, view, source || 'link');
  }

  function hydratePlaceHotspots(root) {
    qsa('[data-lg-component="place-hotspot"]', root).forEach(function hydrate(node) {
      var x = Number(node.getAttribute('data-x'));
      var y = Number(node.getAttribute('data-y'));
      if (Number.isFinite(x)) node.style.setProperty('--x', Math.max(0, Math.min(100, x)) + '%');
      if (Number.isFinite(y)) node.style.setProperty('--y', Math.max(0, Math.min(100, y)) + '%');
    });
  }

  function openPlaceHotspot(root, node) {
    var view = clean(node.getAttribute('data-lg-target-view') || 'brief');
    var url = getUrl();
    if (!url) return navigate(root, view, 'place-hotspot');
    var island = clean(node.getAttribute('data-island-handle') || node.getAttribute('data-island'));
    var mission = clean(node.getAttribute('data-mission-handle') || node.getAttribute('data-mission'));
    var place = clean(node.getAttribute('data-place-id') || node.getAttribute('data-place'));
    if (island) url.searchParams.set('island', island);
    if (mission) url.searchParams.set('mission', mission);
    if (place) url.searchParams.set('place_id', place);
    navigate(root, view, 'place-hotspot', url.pathname + url.search + url.hash);
  }

  function clueKey() {
    var url = getUrl();
    var pathMission = '';

    if (url) {
      var pathSegments = url.pathname.split('/').filter(Boolean);
      var finalSegment = clean(pathSegments[pathSegments.length - 1] || '');

      if (finalSegment && finalSegment !== 'game') {
        pathMission = finalSegment;
      }
    }

    var round = url
      ? clean(
          url.searchParams.get('round_key') ||
          url.searchParams.get('mission_id') ||
          url.searchParams.get('mission') ||
          pathMission ||
          url.searchParams.get('g') ||
          'default'
        )
      : 'default';

    return 'clues_' + round;
  }

  function roundKey() {
    return clueKey().replace('clues_', '');
  }

  function guessSubmissionKey() {
    return 'guess_submitted_' + roundKey();
  }

  function hasSubmittedGuess(root) {
    return root.dataset.guessSubmittedRound === roundKey()
      || readState(guessSubmissionKey(), false) === true;
  }

  function markGuessSubmitted(root) {
    var currentRound = roundKey();
    root.dataset.guessSubmittedRound = currentRound;
    writeState('guess_submitted_' + currentRound, true);
  }

  function foundClues() {
    var value = readState(clueKey(), []);
    return Array.isArray(value)
      ? value.map(Number).filter(function valid(item) { return item >= 0 && item <= 2; })
      : [];
  }

  function finiteNumber(value, fallback) {
    if (value == null || String(value).trim() === '') return fallback;
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function setText(selector, value, root) {
    var node = qs(selector, root);
    if (node && value != null) node.textContent = String(value);
  }

  function parseJson(value, fallback) {
    try {
      var parsed = JSON.parse(value || '');
      return parsed == null ? fallback : parsed;
    } catch (_) {
      return fallback;
    }
  }

  function syncStatusTime(root) {
    var output = qs('[data-lg-status-time]', root);
    if (!output) return;
    function update() {
      output.textContent = new Intl.DateTimeFormat('en-HK', {
        timeZone: 'Asia/Hong_Kong',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).format(new Date());
    }
    clearInterval(root.__statusTimeTimer);
    update();
    root.__statusTimeTimer = window.setInterval(update, 60000);
  }

  function loadMissionData(root) {
    var d = root.dataset;
    var title = qs('[data-lg-lobby-title]', root);
    var lead = qs('[data-lg-mission-lead]', root);
    var photo = qs('[data-lg-lobby-photo]', root);
    var url = getUrl();

    if (title && d.missionName) title.textContent = d.missionName;
    if (lead && d.missionDescription) lead.textContent = d.missionDescription;
    if (photo && d.missionCover) photo.src = d.missionCover;

    if (d.missionRoundKey && url && !url.searchParams.get('round_key')) {
      url.searchParams.set('round_key', d.missionRoundKey);
      window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    }

    if (d.missionClue1 && d.missionClue2 && d.missionClue3) {
      root.dataset.lgHints = JSON.stringify([d.missionClue1, d.missionClue2, d.missionClue3]);
    }

    var pin = qs('[data-lg-map-pin]', root);
    if (pin) pin.setAttribute('aria-label', '目前標記：' + (d.district || '尚未選擇'));

    var range = qs('[data-lg-year-range]', root);
    if (range) {
      var answerYear = finiteNumber(d.missionAnswerYear, new Date().getFullYear());
      var min = finiteNumber(d.missionYearMin, answerYear - 30);
      var max = finiteNumber(d.missionYearMax, answerYear + 20);
      if (max <= min) max = min + 10;
      var value = finiteNumber(d.missionYearDefault, answerYear);
      value = Math.max(min, Math.min(max, value));
      range.min = String(min);
      range.max = String(max);
      range.value = String(value);
      range.step = String(Math.max(1, finiteNumber(range.step, 1)));
      renderYearLabels(range);
    }

    setText('[data-lg-gfun-reward]', Math.max(0, finiteNumber(d.missionRewardGfun, 0)), root);
    setText('[data-lg-mission-difficulty]', d.missionDifficulty || '—', root);
    setText('[data-lg-mission-duration]', d.missionDuration ? d.missionDuration + ' 分鐘' : '—', root);
    setText('[data-lg-mission-reward-stars]', Math.max(0, finiteNumber(d.missionRewardStars, 0)), root);
    setText('[data-lg-mission-reward-gfun]', Math.max(0, finiteNumber(d.missionRewardGfun, 0)), root);
    setText('[data-lg-header-streak]', Math.max(0, finiteNumber(d.profileStreak, 0)), root);
    setText('[data-lg-header-stars]', Math.max(0, finiteNumber(d.profileStars, 0)), root);
    setText('[data-lg-header-level]', Math.max(1, finiteNumber(d.profileLevel, 1)), root);
    setText('[data-lg-share-round]', d.missionRoundKey || '空間情報', root);
    setText('[data-lg-share-mission-name]', d.missionName || 'LittleG 城市探索', root);
    activateGuessWidget(root, d.missionGameplayMode || 'text-input');
    loadProgress(root);
  }

  function renderClues(root, found) {
    var unique = found.filter(function (item, index, values) { return values.indexOf(item) === index; });
    var screen = qs('[data-lg-screen="photo"]', root);
    if (!screen) return unique;

    qsa('[data-lg-hotspot]', screen).forEach(function (node) {
      var selected = unique.indexOf(Number(node.getAttribute('data-lg-hotspot'))) !== -1;
      node.classList.toggle('is-found', selected);
      node.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    qsa('[data-lg-clue-slot]', screen).forEach(function (node) {
      var selected = unique.indexOf(Number(node.getAttribute('data-lg-clue-slot'))) !== -1;
      node.classList.toggle('is-found', selected);
      var label = qs('b', node);
      if (label) label.textContent = selected ? '✓' : '?';
    });
    qsa('[data-lg-clue-count]', screen).forEach(function (node) { node.textContent = String(unique.length); });
    var next = qs('[data-lg-next-after-clues]', screen);
    if (next) next.setAttribute('aria-disabled', unique.length === 3 ? 'false' : 'true');
    writeState(clueKey(), unique);
    return unique;
  }

  function selectClue(root, node) {
    var index = Number(node.getAttribute('data-lg-hotspot'));
    var found = foundClues();
    if (found.indexOf(index) === -1) found.push(index);
    found = renderClues(root, found);
    if (found.length === 3) {
      stopTimer(root);
      toast(root, '已找到 3 條線索，前往猜地點與年份。');
      window.setTimeout(function () { navigate(root, 'guess', 'clues-complete'); }, 550);
    } else {
      toast(root, '找到第 ' + found.length + ' 條線索。');
    }
  }

  function showHint(root) {
    var found = foundClues();
    var next = [0, 1, 2].filter(function (index) { return found.indexOf(index) === -1; })[0];
    if (next == null) return toast(root, '三條線索已經找齊。');
    var hints = parseJson(root.dataset.lgHints, []);
    if (!Array.isArray(hints) || hints.length < 3) hints = ['觀察建築細節。', '留意交通工具。', '看看街道標記。'];
    var hotspot = qs('[data-lg-screen="photo"] [data-lg-hotspot="' + next + '"]', root);
    if (hotspot) hotspot.classList.add('is-next');
    toast(root, hints[next]);
  }

  function renderYearLabels(input) {
    var widget = input.closest('[data-lg-guess-widget]');
    var labels = widget && qs('[data-lg-year-labels]', widget);
    if (!labels) return;
    var min = finiteNumber(input.min, 0);
    var max = finiteNumber(input.max, min);
    var mid = Math.round((min + max) / 2);
    labels.textContent = '';
    [min, mid, max].filter(function (value, index, values) { return values.indexOf(value) === index; }).forEach(function (value) {
      var span = document.createElement('span');
      span.textContent = String(value);
      labels.appendChild(span);
    });
  }

  function normaliseGameplayMode(value) {
    value = clean(value).replace(/_/g, '-');
    var aliases = {
      location: 'location-map',
      map: 'location-map',
      year: 'year-slider',
      text: 'text-input',
      multiplechoice: 'mcq',
      district: 'district-select',
      era: 'era-select',
      open: 'open-clue'
    };
    value = aliases[value] || value;
    return ['location-map', 'year-slider', 'text-input', 'mcq', 'district-select', 'era-select', 'open-clue'].indexOf(value) !== -1
      ? value
      : 'text-input';
  }

  function syncGuessSubmit(root, answered) {
    var submit = qs('[data-lg-submit-guess]', root);
    if (!submit) return;
    answered = answered === true;
    submit.dataset.lgGuessAnswerState = answered ? 'ready' : 'empty';
    submit.setAttribute('aria-disabled', answered ? 'false' : 'true');
    submit.setAttribute('tabindex', answered ? '0' : '-1');
  }

  function activateGuessWidget(root, mode) {
    mode = normaliseGameplayMode(mode);
    root.dataset.activeGuessWidget = mode;
    qsa('[data-lg-guess-widget]', root).forEach(function (widget) {
      var active = widget.getAttribute('data-lg-guess-widget') === mode;
      widget.hidden = !active;
      widget.setAttribute('aria-hidden', active ? 'false' : 'true');
      qsa('input, select, textarea, button', widget).forEach(function (control) { control.disabled = !active; });
    });
    var range = qs('[data-lg-year-range]', root);
    if (mode === 'year-slider' && range) {
      updateYear(range);
      syncGuessSubmit(root, true);
    } else {
      syncGuessSubmit(root, false);
    }
  }

  function updateYear(input) {
    var screen = input.closest('[data-lg-screen="guess"]');
    var output = screen && qs('[data-lg-year-output]', screen);
    var submit = screen && qs('[data-lg-submit-guess]', screen);
    var min = finiteNumber(input.min, 0);
    var max = finiteNumber(input.max, min + 1);
    var value = Math.max(min, Math.min(max, finiteNumber(input.value, min)));
    var ratio = max > min ? ((value - min) / (max - min)) * 100 : 0;
    input.style.background = 'linear-gradient(90deg, var(--lg-app-gold) 0 ' + ratio + '%, #e3e4e4 ' + ratio + '% 100%)';
    if (output) {
      output.textContent = String(value);
      output.style.left = ratio + '%';
      output.style.opacity = '1';
      clearTimeout(output.__hideTimer);
      output.__hideTimer = window.setTimeout(function () { output.style.opacity = '0'; }, 900);
    }
    if (submit) {
      var href = submit.getAttribute('href');
      if (href) {
        var url = new URL(href, window.location.origin);
        url.searchParams.set('year', String(value));
        submit.setAttribute('href', url.pathname + url.search + url.hash);
      }
    }
    syncGuessSubmit(screen && screen.closest(ROOT_SELECTOR), true);
  }

  function zoomMap(root, direction) {
    var map = qs('[data-lg-screen="guess"] [data-lg-map]', root);
    var image = map && qs('img', map);
    if (!image) return;
    var zoom = finiteNumber(map.dataset.zoom, 1.02) + (direction === 'in' ? 0.1 : -0.1);
    zoom = Math.max(1, Math.min(1.52, zoom));
    map.dataset.zoom = String(zoom);
    image.style.transform = 'scale(' + zoom + ')';
  }

  function resetMap(root) {
    var map = qs('[data-lg-screen="guess"] [data-lg-map]', root);
    var image = map && qs('img', map);
    var pin = map && qs('[data-lg-map-pin]', map);
    if (map) map.dataset.zoom = '1.02';
    if (image) image.style.transform = 'scale(1.02)';
    if (pin) {
      pin.style.left = '50%';
      pin.style.top = '42%';
      pin.setAttribute('aria-label', '目前標記：' + (root.dataset.district || '尚未選擇'));
    }
    syncGuessSubmit(root, false);
    toast(root, '標記已重置。');
  }

  function positionPin(root, event) {
    if (event.target.closest && event.target.closest('button')) return;
    var map = event.currentTarget;
    var pin = qs('[data-lg-map-pin]', map);
    if (!pin) return;
    var rect = map.getBoundingClientRect();
    pin.style.left = Math.max(8, Math.min(92, ((event.clientX - rect.left) / rect.width) * 100)) + '%';
    pin.style.top = Math.max(10, Math.min(88, ((event.clientY - rect.top) / rect.height) * 100)) + '%';
    pin.setAttribute('aria-label', '目前標記：自選位置');
    syncGuessSubmit(root, true);
    toast(root, '已更新你的地點標記。');
  }

  function syncFavourite(root) {
    var button = qs('[data-lg-favorite]', root);
    if (!button) return;
    var key = clueKey().replace('clues_', '');
    button.setAttribute('aria-pressed', readState('favourite_' + key, false) === true ? 'true' : 'false');
  }

  function toggleFavourite(root, button) {
    var selected = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    writeState('favourite_' + clueKey().replace('clues_', ''), selected);
    toast(root, selected ? '已加入這部裝置的最愛。' : '已從這部裝置的最愛移除。');
  }

  function readLocalResults() {
    try {
      var value = JSON.parse(window.localStorage.getItem('littleg_offline_city_missions') || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  }

  function loadProgress(root) {
    var streak = Math.max(0, finiteNumber(root.dataset.profileStreak, finiteNumber(readState('streak_days', 0), 0)));
    setText('[data-lg-streak-days]', streak, root);
    setText('[data-lg-share-streak]', streak, root);
    setText('[data-lg-profile-streak]', streak, root);
    return { streak: streak, results: readLocalResults() };
  }

  function showReveal(root) {
    var gate = qs('[data-lg-reveal-gate]', root);
    var content = qs('[data-lg-reveal-content]', root);
    var submitted = hasSubmittedGuess(root);
    if (gate) gate.hidden = submitted;
    if (content) content.hidden = !submitted;
    if (!submitted) return;

    var thenImage = qs('[data-lg-compare-img-then]', root);
    var compare = qs('[data-lg-compare-block]', root);
    if (thenImage && root.dataset.missionCompareImageThen) {
      thenImage.src = root.dataset.missionCompareImageThen;
      thenImage.alt = (root.dataset.missionName || '城市探索') + '昔日影像';
      if (compare) compare.hidden = false;
    } else if (compare) {
      compare.hidden = true;
    }
    setText('[data-lg-compare-year-then]', root.dataset.missionCompareYear || root.dataset.missionAnswerYear || '', root);
    loadProgress(root);
  }

  function loadMapStats(root) {
    var entries = readLocalResults();
    var foundIds = {};
    var districtCounts = {};
    entries.forEach(function (entry) {
      var id = clean(entry.result_id || entry.record_id || entry.card_id || entry.round_key);
      if (id) foundIds[id] = true;
      var district = clean(entry.district_slug || entry.district || entry.location_district);
      if (district) districtCounts[district] = (districtCounts[district] || 0) + 1;
    });
    var found = Object.keys(foundIds).length;
    var total = Math.max(found, finiteNumber(root.dataset.mapCatalogTotal, 0));
    setText('[data-lg-map-found]', found, root);
    setText('[data-lg-map-total]', total, root);
    qsa('[data-lg-map-district]', root).forEach(function (node) {
      var key = clean(node.getAttribute('data-lg-map-district'));
      setText('[data-lg-map-district-progress]', String(districtCounts[key] || 0) + ' 已發現', node);
    });
    var empty = qs('[data-lg-recent-cards] .lg-explorer-map__empty', root);
    if (empty) empty.hidden = entries.length > 0;
  }

  function initProfile(root) {
    var authenticated = root.dataset.customerState === 'authenticated';
    var auth = qs('[data-lg-profile-auth]', root);
    var guest = qs('[data-lg-profile-guest]', root);
    if (auth) auth.hidden = !authenticated;
    if (guest) guest.hidden = authenticated;
    if (!authenticated) return;

    var progress = loadProgress(root);
    var level = Math.max(1, finiteNumber(root.dataset.profileLevel, 1));
    var xp = Math.max(0, finiteNumber(root.dataset.profileXp, 0));
    var target = Math.max(1, finiteNumber(root.dataset.profileXpTarget, 100));
    setText('[data-lg-profile-name]', root.dataset.profileName || '小G', root);
    setText('[data-lg-profile-level]', level, root);
    setText('[data-lg-profile-xp]', xp, root);
    setText('[data-lg-profile-xp-target]', target, root);
    setText('[data-lg-profile-total]', progress.results.length, root);

    qsa('[data-lg-profile-avatar]', root).forEach(function (image) {
      if (root.dataset.profileAvatar) image.src = root.dataset.profileAvatar;
    });
    var meter = qs('[data-lg-profile-progress]', root);
    if (meter) {
      meter.value = Math.min(xp, target);
      meter.max = target;
      meter.textContent = xp + ' / ' + target;
    }

    var badges = parseJson(root.dataset.profileBadges, []);
    if (!Array.isArray(badges)) badges = [];
    var host = qs('[data-lg-profile-badges]', root);
    if (host) {
      host.textContent = '';
      badges.forEach(function (badge) {
        var article = document.createElement('article');
        var strong = document.createElement('strong');
        strong.textContent = clean(badge && (badge.label || badge.name || badge.title) || badge);
        if (strong.textContent) {
          article.appendChild(strong);
          host.appendChild(article);
        }
      });
    }
    var badgeCount = host ? host.children.length : 0;
    setText('[data-lg-profile-badge-count]', badgeCount, root);
    var empty = qs('[data-lg-profile-badges-empty]', root);
    if (empty) empty.hidden = badgeCount > 0;
  }

  function sharePayload(root) {
    var current = getUrl();
    var roundKey = root.dataset.missionRoundKey || (current && (current.searchParams.get('round_key') || current.searchParams.get('g'))) || 'today';
    var shareUrl;
    try {
      shareUrl = current ? new URL(current.toString()) : new URL('/pages/game', window.location.origin);
    } catch (_) {
      shareUrl = new URL('/pages/game', window.location.origin);
    }
    shareUrl.searchParams.set('view', 'share');
    shareUrl.searchParams.set('round_key', roundKey);
    shareUrl.searchParams.delete('mode');
    shareUrl.searchParams.delete('share-card');
    shareUrl.searchParams.delete('clue');
    shareUrl.searchParams.delete('game_result');
    shareUrl.hash = '';
    return {
      title: 'LittleG',
      text: '我完成了今日的城市探索任務。',
      url: shareUrl.toString()
    };
  }

  function copyShare(root, value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(function () {
        toast(root, '分享文字已複製。');
      }).catch(function () {
        toast(root, '未能複製，請使用更多分享。');
      });
      return;
    }
    toast(root, '此瀏覽器不支援自動複製。');
  }

  function shareResult(root, button) {
    var channel = clean(button.getAttribute('data-lg-share') || 'native');
    var payload = sharePayload(root);
    if (channel === 'whatsapp') {
      window.open('https://wa.me/?text=' + encodeURIComponent(payload.text + ' ' + payload.url), '_blank', 'noopener,noreferrer');
      return;
    }
    if (channel === 'instagram') {
      copyShare(root, payload.text + ' ' + payload.url);
      toast(root, '已準備分享文字；Instagram 網頁版不支援直接發佈限時動態。');
      return;
    }
    if (navigator.share) {
      navigator.share(payload).catch(function () {});
      return;
    }
    copyShare(root, payload.text + ' ' + payload.url);
  }

  function initGallery(scope) {
    qsa('[data-stage="gallery"]', scope || document).forEach(function (gallery) {
      var date = new Date(Date.now() + 8 * 60 * 60 * 1000);
      var iso = date.toISOString().slice(0, 10);
      var dateNode = qs('[data-daily-date]', gallery);
      if (dateNode) {
        dateNode.dateTime = iso;
        dateNode.textContent = new Intl.DateTimeFormat('en-HK', {
          timeZone: 'Asia/Hong_Kong',
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        }).format(new Date());
      }
      var dailyCard = qs('[data-daily-mission-card]', gallery);
      var label = qs('[data-daily-mission-label]', gallery);
      if (label) label.textContent = dailyCard
        ? (dailyCard.getAttribute('data-mission-title') || dailyCard.getAttribute('data-mission-key') || 'Today G')
        : 'Today G unavailable';

      var verified = gallery.getAttribute('data-daily-count-verified') === 'true';
      var count = Math.max(0, finiteNumber(gallery.getAttribute('data-daily-count-value'), 0));
      var wrap = qs('[data-daily-count-wrap]', gallery);
      var output = qs('[data-daily-count]', gallery);
      if (output) output.textContent = String(count);
      if (wrap) wrap.hidden = !(verified && count > 0);

      function tickCountdown() {
        var shifted = Date.now() + 8 * 60 * 60 * 1000;
        var next = Math.floor(shifted / 86400000) * 86400000 + 86400000;
        var diff = Math.max(0, next - shifted);
        var hours = Math.floor(diff / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var node = qs('[data-daily-countdown]', gallery);
        if (node) node.textContent = 'Hong Kong time ' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');
      }
      clearInterval(gallery.__dailyCountdown);
      tickCountdown();
      gallery.__dailyCountdown = window.setInterval(tickCountdown, 60000);
    });
  }

  function bind(root) {
    if (!root || root.dataset.runtimeReady === 'true') return;
    root.dataset.runtimeReady = 'true';
    setPageClass();
    loadMissionData(root);
    syncStatusTime(root);
    renderClues(root, foundClues());
    syncFavourite(root);
    hydratePlaceHotspots(root);

    qsa('[data-lg-screen-link]', root).forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var view = clean(link.getAttribute('data-lg-screen-link'));
        if (!isView(view)) return;
        if (link.hasAttribute('data-lg-next-after-clues') && foundClues().length < 3) {
          event.preventDefault();
          toast(root, '先找齊 3 條線索。');
          return;
        }
        if (link.hasAttribute('data-lg-submit-guess')) {
          if (link.getAttribute('aria-disabled') === 'true') {
            event.preventDefault();
            toast(root, '請先完成答案。');
            return;
          }
          markGuessSubmitted(root);
        }
        event.preventDefault();
        navigate(root, view, 'link', link.getAttribute('href'));
      });
    });

    qsa('[data-lg-back]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        if (window.history.length > 1) window.history.back();
        else navigate(root, 'lobby', 'back-fallback');
      });
    });
    qsa('[data-lg-hotspot]', root).forEach(function (node) {
      node.addEventListener('click', function () { selectClue(root, node); });
    });
    qsa('[data-lg-component="place-hotspot"]', root).forEach(function (node) {
      node.addEventListener('click', function () { openPlaceHotspot(root, node); });
    });
    qsa('[data-lg-hint]', root).forEach(function (button) {
      button.addEventListener('click', function () { showHint(root); });
    });
    qsa('[data-lg-skip]', root).forEach(function (button) {
      button.addEventListener('click', function () { navigate(root, 'guess', 'skip'); });
    });
    qsa('[data-lg-year-range]', root).forEach(function (input) {
      input.addEventListener('input', function () { updateYear(input); });
    });
    qsa('[data-lg-map-zoom]', root).forEach(function (button) {
      button.addEventListener('click', function () { zoomMap(root, clean(button.getAttribute('data-lg-map-zoom'))); });
    });
    qsa('[data-lg-map-locate]', root).forEach(function (button) {
      button.addEventListener('click', function () { resetMap(root); });
    });
    qsa('[data-lg-map]', root).forEach(function (map) {
      map.addEventListener('click', function (event) { positionPin(root, event); });
    });
    qsa('[data-lg-favorite]', root).forEach(function (button) {
      button.addEventListener('click', function () { toggleFavourite(root, button); });
    });
    qsa('[data-lg-share]', root).forEach(function (button) {
      button.addEventListener('click', function () { shareResult(root, button); });
    });
    qsa('[data-lg-search]', root).forEach(function (button) {
      button.addEventListener('click', function () { toast(root, '搜尋入口沿用 LittleG 全站搜尋。'); });
    });
    qsa('[data-lg-notification]', root).forEach(function (button) {
      button.addEventListener('click', function () { toast(root, '今日沒有新的探索通知。'); });
    });

    qsa('[data-lg-guess-widget] input, [data-lg-guess-widget] select, [data-lg-guess-widget] textarea', root).forEach(function (control) {
      control.addEventListener('input', function () {
        if (control.hasAttribute('data-lg-year-range')) return;
        syncGuessSubmit(root, clean(control.value).length > 0);
      });
      control.addEventListener('change', function () {
        syncGuessSubmit(root, clean(control.value).length > 0);
      });
    });

    activate(root, resolveView(getUrl()), 'initial');
    emit('littleg:game-ready', {
      contract: 'GAME-REFERENCE-SYSTEM-01-09',
      header_owner: 'sections/littleg-game-lobby.liquid',
      navigation_owner: 'snippets/littleg-app-sidebar.liquid'
    });
  }

  function boot(scope) {
    setPageClass();
    qsa(ROOT_SELECTOR, scope || document).forEach(bind);
    initGallery(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  window.addEventListener('popstate', function () {
    var root = qs(ROOT_SELECTOR);
    if (root) activate(root, resolveView(getUrl()), 'popstate');
  });
  document.addEventListener('shopify:section:load', function (event) { boot(event.target || document); });
})(window, document);
